export const STEPS = [
  { id: 'address', label: 'Address', hint: 'the address is the key — one typed input' },
  { id: 'property', label: 'Property', modules: ['property identity', 'building', 'construction', 'condition & maintenance', 'occupancy & use', 'hazards', 'rural/lifestyle', 'security'], hint: 'prefilled from the registers — confirm or change' },
  { id: 'tenancy', label: 'Tenancy', modules: ['landlord tenancy'], landlordOnly: true, hint: 'tenancy, rent and management' },
  { id: 'cover', label: 'Cover', modules: ['sums insured & cover', 'insured persons', 'insurance & claims history', 'payment'], hint: 'sum insured from the indicative rebuild' },
  { id: 'disclosure', label: 'Disclosure', modules: ['disclosure'], hint: 's20B — the duty to take reasonable care' },
  { id: 'price', label: 'Price', hint: 'three options, the drivers, what refers' },
  { id: 'bind', label: 'Bind', hint: 'one door — the same gates as every bind' },
  { id: 'documents', label: 'Documents', hint: 'watermarked demo documents' },
];

export const stepsFor = variant => STEPS.filter(s => !s.landlordOnly || variant === 'landlord');

export const modulesFor = (rendered, step) => (rendered?.modules || []).filter(m => (step.modules || []).includes(m.name));

export const missingIn = (rendered, step) => {
  const ids = new Set(modulesFor(rendered, step).flatMap(m => m.questions.filter(q => q.visible).map(q => q.id)));
  return (rendered?.missing_required || []).filter(id => ids.has(id));
};

export const money = v => (v === null || v === undefined ? '—' : `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
